import type { QuotaConfig } from '@efira/protocol';

/**
 * Сообщение зрителю об исчерпании дневной квоты.
 *
 * ЭТО ЕДИНСТВЕННОЕ ИСКЛЮЧЕНИЕ ИЗ ПРАВИЛА МОЛЧАЛИВОГО OVERLAY, введённого в
 * блоке 4а. Правило звучало так: состояния подключения видны разработчику, но
 * не зрителю эфира — зрителю нечего делать с нашими техническими сообщениями,
 * а кадр эфира не наша витрина.
 *
 * Здесь оно не работает. Зритель, у которого перестала работать игра, сделает
 * ровно один вывод: сломался стример. Он не знает ни про квоту, ни про нас, и
 * узнать ему неоткуда — значит, виноват тот, кого он видит.
 *
 * У конкурента сделано хуже всего возможного: игра продолжает идти, а поток
 * событий замирает. Комментарии и подарки перестают на что-либо влиять, и
 * объяснения нет ни стримеру, ни зрителю (`PRICING_LIMITS.md`, 2.1 — «худший
 * из возможных вариантов деградации: молчаливый отказ вместо явного
 * сообщения»). Зритель, отправивший подарок в этот момент, заплатил монетами
 * ни за что.
 *
 * ТОН. Короткий, без обвинения и без агрессивной продажи. Не «стример не
 * оплатил» — это ложь и удар по тому, ради кого зритель пришёл. Не «купите
 * Pro» — зрителю нечего покупать, платит стример. Эфир при этом продолжается:
 * приостановлена игра, а не трансляция, и сказать надо именно это.
 */
export function QuotaNotice({ quota }: { quota: QuotaConfig }) {
  if (!quota.exhausted) {
    return null;
  }

  return (
    <div className="quota-notice" role="status">
      <p className="quota-notice__title">Игра приостановлена до завтра</p>
      <p className="quota-notice__text">
        Дневное время игр на сегодня закончилось. Эфир продолжается.
      </p>
    </div>
  );
}
